import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Popconfirm } from 'antd';
import { ReferenceDataVisualStore } from '../../stores';
import { HasPermission } from '../../../authorization/components/HasPermission';
import { AppPermissions } from '../../../authorization/Permissions';

interface Props {
    store: ReferenceDataVisualStore;
    tableName: string;
}

const TableTitle: React.FC<Props> = ({ store, tableName }) => {
    return (
        <div className="title-item" onClick={() => store.handleTableSelect(tableName)}>
            <span data-testid={tableName}>{tableName}</span>

            {store.currentConnection?.isReadOnly ? null : (
                <HasPermission
                    entityId={store.currentProject.id}
                    permissionClaim={AppPermissions.CanEditIotaConnections}
                >
                    <div className="title-item-actions">
                        <Button
                            size="small"
                            type="link"
                            onClick={(e: React.MouseEvent<HTMLElement>) => {
                                e.stopPropagation();

                                store.handleTableEdit(tableName);
                            }}
                        >
                            <i className="alpha-icon lg edit-icon" />
                        </Button>

                        <Popconfirm
                            title="Sure to delete?"
                            onCancel={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
                            onConfirm={(e: React.MouseEvent<HTMLElement>) => {
                                e.stopPropagation();

                                store.deleteTable(tableName);
                            }}
                        >
                            <Button
                                id={tableName}
                                onClick={e => e.stopPropagation()}
                                type="link"
                                size="small"
                                data-testid={`delete-table-${tableName}`}
                            >
                                <i className="alpha-icon lg delete-icon" />
                            </Button>
                        </Popconfirm>
                    </div>
                </HasPermission>
            )}
        </div>
    );
};

export default observer(TableTitle);
